const toolkit = [
  { id: 't1', tKey: 'toolkit.t1', icon: 'terminal' },
  { id: 't2', tKey: 'toolkit.t2', icon: 'monitor' },
  { id: 't3', tKey: 'toolkit.t3', icon: 'git-branch' },
  { id: 't4', tKey: 'toolkit.t4', icon: 'code' },
  { id: 't5', tKey: 'toolkit.t5', icon: 'bug' },
  { id: 't6', tKey: 'toolkit.t6', icon: 'settings' },
];

export default toolkit;
